import React from "react";

import {
  Card,
  CardBody,
  Button,
} from "reactstrap";

const BillingSection = ({

  propertyProfile,

  cart,

  subTotal,

  gstAmount,

  grandTotal,

  generateKOT,

  activeOrder,

}) => {

  return (

    <Card

      style={{

        borderRadius: 8,

        boxShadow: "none",

      }}

    >

      <CardBody

        style={{

          display: "flex",

          flexDirection:
            "column",

          height: "100%",

        }}

      >


        {/* ======================
            PROPERTY DETAILS
        ====================== */}

        <div className="mb-4">

          <h4
            className="mb-1"
            style={{
              fontWeight: 700,
            }}
          >

            {
              propertyProfile
                ?.legalBusinessName ||

              "Property Name"
            }

          </h4>


          <div
            style={{
              fontSize: 12,
              color: "#666",
              lineHeight: "20px",
            }}
          >

            <div>

              GSTIN:

              {" "}

              {
                propertyProfile
                  ?.gstNumber ||

                "N/A"
              }

            </div>


            <div>

              PAN:

              {" "}

              {
                propertyProfile
                  ?.panNumber ||

                "N/A"
              }

            </div>

          </div>


          <div
            style={{
              fontSize: 13,
              color: "#777",
              marginTop: 6,
            }}
          >

            {new Date()
              .toLocaleDateString()}

            {" | "}

            {new Date()
              .toLocaleTimeString()}

          </div>

        </div>


        <hr />


        {/* ======================
            CART HEADER
        ====================== */}

        <div

          className="
            d-flex
            fw-bold
            mb-3
            pb-2
          "

          style={{

            borderBottom:
              "1px solid #eee",

            fontSize: 13,

          }}

        >

          <div style={{ flex: 2 }}>
            Item
          </div>


          <div
            style={{
              flex: 1,
              textAlign: "center",
            }}
          >
            Qty
          </div>


          <div
            style={{
              flex: 1,
              textAlign: "right",
            }}
          >
            Price
          </div>


          <div
            style={{
              flex: 1,
              textAlign: "right",
            }}
          >
            Total
          </div>

        </div>


        {/* ======================
            CART ITEMS
        ====================== */}

        <div
          style={{

            flex: 1,

            overflowY:
              "auto",

          }}
        >

          {cart.length === 0 && (

            <div
              className="
                text-center
                text-muted
                py-4
              "
            >

              No items added

            </div>

          )}


          {cart.map(
            (item, index) => (

              <div

                key={index}

                className="
                  d-flex
                  align-items-center
                  py-2
                "

                style={{

                  borderBottom:
                    "1px solid #f5f5f5",

                }}

              >


                {/* NAME */}

                <div
                  style={{
                    flex: 2,
                    paddingRight: 10,
                  }}
                >

                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >

                    {item.name?.en}


                    {item.name?.hi && (

                      <div
                        style={{
                          fontSize: 11,
                          color: "#6c757d",
                          fontWeight: 400,
                        }}
                      >

                        {item.name.hi}

                      </div>

                    )}

                  </div>


                  <small
                    style={{
                      color: "#777",
                    }}
                  >

                    {item.size}

                  </small>

                </div>


                {/* QUANTITY */}

                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >

                  {item.quantity}

                </div>


                {/* PRICE */}

                <div
                  style={{
                    flex: 1,
                    textAlign: "right",
                  }}
                >

                  ₹
                  {item.finalPrice}

                </div>


                {/* TOTAL */}

                <div
                  style={{
                    flex: 1,
                    textAlign: "right",
                    fontWeight: 600,
                  }}
                >

                  ₹
                  {(
                    item.finalPrice *
                    item.quantity
                  ).toFixed(0)}

                </div>

              </div>

            )
          )}

        </div>


        <hr />


        {/* ======================
            TOTALS
        ====================== */}

        <div
          className="
            mb-2
            d-flex
            justify-content-between
          "
        >

          <span>
            Sub Total
          </span>


          <span>

            ₹
            {subTotal.toFixed(2)}

          </span>

        </div>


        <div
          className="
            mb-2
            d-flex
            justify-content-between
          "
        >

          <span>
            GST (5%)
          </span>


          <span>

            ₹
            {gstAmount.toFixed(2)}

          </span>

        </div>


        <hr />


        <div
          className="
            mb-4
            d-flex
            justify-content-between
            fw-bold
          "
        >

          <span>
            Grand Total
          </span>


          <span>

            ₹
            {grandTotal.toFixed(2)}

          </span>

        </div>


        {/* ======================
            GENERATE
        ====================== */}

        <Button

          color="success"

          size="md"

          block

          disabled={
            !cart.length
          }

          onClick={
            generateKOT
          }

          style={{
            borderRadius: 6,
            fontWeight: 600,
          }}

        >

          Generate

        </Button>

      </CardBody>

    </Card>

  );

};

export default BillingSection;